import { render, staticRenderFns } from "./addClassPage.vue?vue&type=template&id=6f849b43&scoped=true"
import script from "./addClassPage.vue?vue&type=script&lang=js"
export * from "./addClassPage.vue?vue&type=script&lang=js"
import style0 from "./addClassPage.vue?vue&type=style&index=0&id=6f849b43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f849b43",
  null
  
)

component.options.__file = "addClassPage.vue"
export default component.exports